import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (): Promise<boolean> => {
	const authService = inject(AuthService);
	const router = inject(Router);

	if (!authService.initialized) {
		await authService.checkSession();
	}

	if (authService.isLoggedIn) {
		return true;
	}

	void router.navigate(['/login']);
	return false;
};
